import React from "react";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import { Box, Stack, Typography } from "@mui/material";

function activityMeta(type) {
  if (type === "action_completed") {
    return { icon: <TaskAltRoundedIcon sx={{ fontSize: 18 }} />, color: "#17345d", bg: "rgba(23, 52, 93, 0.08)" };
  }
  if (type === "checkin") {
    return { icon: <CheckCircleOutlineRoundedIcon sx={{ fontSize: 18 }} />, color: "#2e8b76", bg: "rgba(46, 139, 118, 0.1)" };
  }
  if (type === "update" || type === "message") {
    return { icon: <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 18 }} />, color: "#5c55ef", bg: "rgba(92, 85, 239, 0.1)" };
  }
  if (type === "sprint_start") {
    return { icon: <RestartAltRoundedIcon sx={{ fontSize: 18 }} />, color: "#ff8a17", bg: "rgba(255, 138, 23, 0.1)" };
  }
  return { icon: <BoltRoundedIcon sx={{ fontSize: 18 }} />, color: "#70839a", bg: "rgba(112, 131, 154, 0.1)" };
}

export default function PersonActivityList({ items }) {
  return (
    <Box
      sx={{
        borderRadius: 4,
        border: "1px solid rgba(224, 231, 240, 0.92)",
        bgcolor: "#fff",
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
        p: { xs: 2, md: 2.4 },
      }}
    >
      <Stack spacing={1.4}>
        <Typography variant="h6" sx={{ fontWeight: 800, color: "#16213f" }}>
          Recent activity
        </Typography>
        {(items || []).length ? (
          <Stack spacing={1.1}>
            {items.map((item) => {
              const meta = activityMeta(item.type);
              return (
                <Stack
                  key={item.id}
                  direction="row"
                  spacing={1.2}
                  alignItems="flex-start"
                  sx={{
                    px: 1.2,
                    py: 1.2,
                    borderRadius: 2.5,
                    bgcolor: "#fbfcfe",
                  }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "50%",
                      display: "grid",
                      placeItems: "center",
                      bgcolor: meta.bg,
                      color: meta.color,
                      flexShrink: 0,
                    }}
                  >
                    {meta.icon}
                  </Box>
                  <Stack spacing={0.2} sx={{ minWidth: 0 }}>
                    <Typography variant="body1" sx={{ color: "#13233c", fontWeight: 700 }}>
                      {item.title}
                    </Typography>
                    {item.detail ? (
                      <Typography variant="body2" sx={{ color: "#5f7085" }}>
                        {item.detail}
                      </Typography>
                    ) : null}
                    <Typography variant="caption" sx={{ color: "#7b8794", fontWeight: 700 }}>
                      {item.timestamp_label || ""}
                    </Typography>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        ) : (
          <Typography variant="body2" sx={{ color: "#70839a" }}>
            No recent activity is shared here yet.
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
